"use client";
import React from "react";
import ESRiskBanner from "./es";
import MiCARiskBanner from "./mica";
import UKRiskBanner from "./uk";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";
import { isIn } from "utils/arrays";

const COUNTRY_WITH_RISK_BANNER = ["GB", "ES"] as const;

type CountryWithRiskBanner = (typeof COUNTRY_WITH_RISK_BANNER)[number];

const CountryToRiskBanner = {
  ES: ESRiskBanner,
  GB: UKRiskBanner
} as const satisfies Record<CountryWithRiskBanner, React.ComponentType>;

const RiskBanner = () => {
  const { country, isEU } = useCountryStateCookies();

  if (isEU) {
    return <MiCARiskBanner />;
  }

  if (!isIn(COUNTRY_WITH_RISK_BANNER, country)) {
    return null;
  }

  const RiskBannerComponent =
    CountryToRiskBanner[country as CountryWithRiskBanner];

  return <RiskBannerComponent id="risk-banner" />;
};

export default RiskBanner;
